const config = require("../config.js");
var UTILS = require("../libs/utils.js");
const vF85 = (p12612, p12613, p12614, p12615) => {
  if (p12612) {
    p12612.soundData = SOUND.play3DL("egg_0", p12613, p12614, p12615, 0.8);
  }
};
const vF86 = (p12616, p12617, p12618, p12619) => {
  if (!p12617 && p12619 && p12619.soundData) {
    p12619.soundData[0].isPlaying = false;
    p12619.soundData[0].stop(p12619.soundData[1]);
    p12619.soundData = null;
  }
};
var v10150;
var v10151;
module.exports = [{
  name: "Tag",
  model: "tag_0",
  scale: 6,
  padMlt: 0.8,
  yOff: 6,
  timer: 8000,
  emissive: function (p12620, p12621) {
    if (p12620) {
      if (p12621 == p12620.team) {
        return 8729652;
      } else {
        return 4360861;
      }
    } else {
      return 4360861;
    }
  },
  onPickup: function (game, p12623, p12624, p12625) {
    if (p12624.team == p12625.team) {
      p12624.denies++;
      game.incMedal("Denied", p12624);
      p12624.send("am", [29, 10, 0, 1]);
      game.players.score(p12624, 10, 2);
      game.challenges.update(game, "dym", 1, null, p12624);
    } else {
      game.players.teamScore(p12624, 1);
      p12624.confirms++;
      game.incMedal("Confirmed", p12624);
      p12624.send("am", [30, 25, 0, 1]);
      game.players.score(p12624, 25, 2);
      if (game.playSound) {
        game.playSound(config.networkSounds.indexOf("collect_1"), 1.2, p12624.sid, p12624.x, p12624.y, p12624.z, true);
      }
      game.challenges.update(game, "cnf", 1, null, p12624);
    }
  }
}, {
  name: "Gift",
  model: "gift_0",
  scale: 3,
  yOff: 6,
  timer: 20000,
  texRange: 3,
  rarities: [{
    chance: 77,
    items: [4379, 4389, 4409]
  }, {
    chance: 20,
    items: [4407, 4391, 4387]
  }, {
    chance: 2.5,
    items: [4399, 4402, 4403, 4408, 4397, 4394, 4390]
  }, {
    chance: 0.5,
    items: [4412, 4395, 4388]
  }],
  stopInteract: function (p12626, p12627, p12628) {
    return !p12627 || !p12628 || !!p12628.isBot || !p12628.account;
  },
  onPickup: function (p12629, p12630, p12631) {
    p12629.challenges.update(p12629, "gifts", 1, null, p12631);
    var v10152;
    var v10153 = UTILS.randFloat(0, 100).round(2);
    var vLN01622 = 0;
    var vLN01623 = 0;
    for (var vLN01624 = 0; vLN01624 < this.rarities.length; ++vLN01624) {
      v10152 = this.rarities[vLN01624].chance;
      vLN01623 += v10152;
      if (v10153 <= vLN01623) {
        vLN01622 = vLN01624;
        break;
      }
    }
    var v10154 = UTILS.getRandom(this.rarities[vLN01622].items);
    if (v10154) {
      p12629.giveSkin(p12631, v10154, "christmas");
    }
    if (p12629.playSound) {
      p12629.playSound(config.networkSounds.indexOf("gift_0"), 1.2, p12631.sid, p12631.x, p12631.y, p12631.z, true);
    }
  }
}, {
  name: "Golden Egg",
  model: "egg_0",
  texSrc: "egg_0_4",
  scale: 3,
  yOff: 1,
  noAnim: true,
  timer: 40000,
  onSpawn: function (p12632, p12633, p12634, p12635) {
    SOUND.play3DL("egg_0", p12633, p12634, p12635, 0.5);
  },
  stopInteract: function (p12636, p12637, p12638) {
    if (p12637) {
      return !p12638 || !!p12638.isBot || !p12638.account || p12638.meleeIndex != 4797 || p12638.currentWeaponId != 12 || p12638.tempEggs.indexOf(uniqueID) != -1;
    } else if (p12638 && (p12638.meleeIndex != 4797 || p12638.currentWeaponId != 12)) {
      return "<span style='color:var(--yellow);'>Egg Basket is Required</span>";
    } else {
      return "";
    }
  },
  onPickup: function (p12639, p12640, p12641) {},
  onDestroy: function (p12642, p12643) {
    if (p12643) {
      p12642.broadcast("chi", -1, null, ["event.easter.golden.despawn"], 2, "#61fff7");
      return;
    } else {
      return SOUND.stop("egg_0");
    }
  }
}, {
  name: "KR Tag",
  model: "krunkie_0",
  scale: 3.5,
  padMlt: 1.25,
  yOff: 6,
  timer: 12000,
  emissive: function (p12644, p12645) {
    if (p12644) {
      if (p12645 == p12644.team) {
        return 8729652;
      } else {
        return 4360861;
      }
    } else {
      return 4360861;
    }
  },
  getScale: function (p12646) {
    var v10155 = p12646 ? p12646.c || 1 : 1;
    return this.scale + v10155 * 0.5;
  },
  stopInteract: function (p12647, p12648, p12649, p12650) {
    return (!p12647.mode.teams || p12649.team != p12650.team) && (!p12648 || !p12649 || !(p12649.dogTags < p12647.mode.tagHoldLimit));
  },
  onPickup: function (game, p12652, p12653, p12654) {
    var v10156 = p12654.data ? p12654.data.c || 0 : 0;
    var v10157 = game.mode.teams ? 10 : 5;
    if (game.mode.teams && p12653.team == p12654.team) {
      if (!v10156) {
        v10156 = 1;
      }
      p12653.denies++;
      game.incMedal("Denied", p12653);
      p12653.send("am", [29, v10157, 0, v10156]);
      game.players.score(p12653, v10157);
      game.challenges.update(game, "dym", v10156, null, p12653);
      p12654.dontDestroy = false;
    } else {
      var v10158 = game.mode.tagHoldLimit;
      var vV10156 = v10156;
      if (p12653.dogTags + v10156 > v10158) {
        var v10159 = v10158 - p12653.dogTags;
        p12653.dogTags += v10159;
        p12654.data.c = v10156 - v10159;
        p12654.dontDestroy = true;
        vV10156 = v10159;
      } else {
        p12653.dogTags += v10156;
      }
      game.incMedal("Collected", p12653);
      p12653.send("am", [48, v10157, 0, vV10156]);
      p12653.send("krt", p12653.dogTags);
      game.players.score(p12653, v10157);
      if (game.playSound) {
        game.playSound(config.networkSounds.indexOf("collect_1"), 1.2, p12653.sid, p12653.x, p12653.y, p12653.z, true);
      }
    }
  }
}, {
  name: "Diamond Egg",
  model: "egg_0",
  texSrc: "egg_0_5",
  scale: 2,
  yOff: 6,
  timer: 12000,
  getScale: function (p12655) {
    var v10160 = p12655 ? p12655.c || 1 : 1;
    return this.scale + v10160 * 0.5;
  },
  stopInteract: function (p12656, p12657, p12658, p12659) {
    return (!p12656.mode.teams || p12658.team != p12659.team) && (!p12657 || !p12658 || !(p12658.dogTags < p12656.mode.tagHoldLimit));
  },
  onPickup: function (game, p12661, p12662, p12663) {
    if (game.mode.teams && p12662.team == p12663.team) {
      p12662.denies++;
      game.incMedal("Denied", p12662);
      p12662.send("am", [29, 5, 0, 1]);
      game.players.score(p12662, 5);
      game.challenges.update(game, "dym", 1, null, p12662);
      p12663.dontDestroy = false;
    } else {
      var v10161 = p12663.data ? p12663.data.c || 0 : 0;
      var v10162 = game.mode.tagHoldLimit;
      var vV10161 = v10161;
      if (p12662.dogTags + v10161 > v10162) {
        var v10163 = v10162 - p12662.dogTags;
        p12662.dogTags += v10163;
        p12663.data.c = v10161 - v10163;
        p12663.dontDestroy = true;
        vV10161 = v10163;
      } else {
        p12662.dogTags += v10161;
      }
      game.incMedal("Collected", p12662);
      p12662.send("am", [48, 5, 0, vV10161]);
      p12662.send("krt", p12662.dogTags);
      game.players.score(p12662, 5);
      if (game.playSound) {
        game.playSound(config.networkSounds.indexOf("egg_1"), 1.2, p12662.sid, p12662.x, p12662.y, p12662.z, true);
      }
    }
  }
}, {
  name: "Slime Pad",
  model: "pad_1",
  scale: 4,
  yOff: 0.2,
  noAnim: true,
  timer: 10000,
  alwaysActive: true,
  getRotation: function (p12664) {
    return [UTILS.toRad(p12664.xD), 0, UTILS.toRad(p12664.zD)];
  },
  onCollision: function (p12665, p12666, p12667, p12668) {
    var vLN012510 = 0.125;
    var v10164 = p12668.data && p12668.data.xD ? p12668.data.xD || 0 : 0;
    var v10165 = p12668.data && p12668.data.zD ? p12668.data.zD || 0 : 0;
    var v10166 = !v10164 && !v10165 || v10165 == 180;
    if (v10164) {
      v10164 -= 90;
    }
    if (!v10166) {
      v10164 = UTILS.toRad(v10164);
      v10165 = UTILS.toRad(v10165);
      var v10167 = vLN012510 * Math.sin(-v10165) * Math.cos(v10164);
      var v10168 = vLN012510 * Math.cos(-v10165) * Math.cos(v10164);
      if (v10167) {
        p12667.velocity.x = v10167;
      }
      if (v10168) {
        p12667.velocity.z = v10168;
      }
    } else {
      p12667.velocity.y = vLN012510 * (v10165 == 180 ? -1 : 1);
    }
    if (p12667.isYou && !p12667.wasOnPad) {
      SOUND.play("bounce_1", 1, false, UTILS.randFloat(0.95, 1));
    }
    p12667.onGround = false;
    p12667.onPad = true;
  }
}, {
  name: "Ammo Pack",
  model: "ammobox_0",
  scale: 1.5,
  yOff: 0.25,
  timer: 20000,
  noAnim: true,
  outline: 0,
  icon: 54,
  getRotation: function (p12669) {
    return [0, p12669.xD, 0];
  },
  stopInteract: function (p12670, p12671, p12672) {
    return !p12671 || !p12672 || !!p12672.isBot;
  },
  onPickup: function (game, p12674, p12675, p12676) {
    var v10169 = p12676.data && p12676.data.c ? p12676.data.c || 0 : 0;
    if (v10169 < 10) {
      v10169 = UTILS.randInt(8, 12);
    }
    p12675.ammos[0] += v10169;
    p12675.send("uamo", p12675.ammos, p12675.reserveAmmos);
    if (game.playSound) {
      game.playSound(config.networkSounds.indexOf("reload_3"), 1.2, p12675.sid, p12675.x, p12675.y, p12675.z, true);
    }
    game.players.score(p12675, 5);
    game.incMedal("Scavenger", p12675);
    p12675.send("am", [54, 5, 0, 1]);
    game.challenges.update(game, "amc", p12675.ammos[0], null, p12675);
    game.challenges.update(game, "amp", 1, null, p12675);
  }
}, {
  name: "Weapon Box",
  model: "weaponbox_0",
  scale: 3,
  padMlt: 1.5,
  yOff: 0.9,
  timer: 20000,
  noAnim: true,
  emisTex: true,
  icon: 55,
  emissive: function () {
    return 16777215;
  },
  getRotation: function (p12677) {
    return [0, p12677.xD, 0];
  },
  stopInteract: function (p12678, p12679, p12680) {
    return !p12679 || !p12680 || !!p12680.isBot;
  },
  onPickup: function (game, p12682, p12683, p12684) {
    p12683.pickups++;
    if (p12684.data && p12684.data.wId != null) {
      game.players.replaceLoadout(p12683, [p12684.data.wId]);
      game.challenges.update(game, "wpb", 1, {
        wep: p12684.data.wId
      }, p12683);
      game.players.score(p12683, 5);
      game.incMedal("Armed", p12683);
      p12683.send("am", [55, 5, 0, 1]);
    }
    if (game.playSound) {
      game.playSound(config.networkSounds.indexOf("reload_3"), 1.2, p12683.sid, p12683.x, p12683.y, p12683.z, true);
    }
  }
}, {
  name: "Melee Pickup",
  model: "melee/melee_0",
  scale: 3,
  yOff: 6,
  timer: 20000,
  outline: 0,
  stopInteract: function (p12685, p12686, p12687) {
    var v10170 = Date.now();
    var v10171 = 500 - (v10170 - p12687.lastThrowTime);
    if (!p12686 && p12687) {
      if (p12687.canThrow) {
        return "<span style='color:var(--yellow);'>You already have a melee</span>";
      }
      return !p12687.canThrow && !!(v10171 > 0) && "<span style='color:var(--yellow);'>Wait " + UTILS.getReadableTime(v10171, true) + " to pickup</span>";
    }
    return !p12686 || !p12687 || p12687.isBot || p12687.canThrow;
  },
  onPickup: function (p12688, p12689, p12690) {
    var v10172 = Date.now();
    var v10173 = 500 - (v10172 - p12690.lastThrowTime);
    if (!(v10173 > 0)) {
      p12688.refillPlayer(p12690);
      if (p12688.playSound) {
        p12688.playSound(config.networkSounds.indexOf("melee_equip"), 1.2, p12690.sid, p12690.x, p12690.y, p12690.z, true);
      }
    }
  }
}, {
  name: "Ammo Cache",
  model: "ammobox_0",
  scale: 4.5,
  yOff: 6,
  timer: 20000,
  outline: 1,
  powerup: true,
  outlineScale: 1.1,
  onSpawn: vF85,
  onPickup: function (game, p12692, p12693) {
    var v10174;
    for (var vLN01625 = 0; vLN01625 < game.players.list.length; ++vLN01625) {
      v10174 = game.players.list[vLN01625];
      v10174.resetAmmo(true, true);
      if (v10174 && !v10174.canThrow) {
        game.refillPlayer(v10174);
      }
      v10174.send("uamo", v10174.ammos, v10174.reserveAmmos);
    }
    if (game.playSound) {
      game.playSound(config.networkSounds.indexOf("reload_3"), 1.2, p12693.sid, p12693.x, p12693.y, p12693.z, true);
    }
  },
  onDestroy: vF86
}, {
  name: "Nuke",
  model: "streak_0",
  scale: 4.5,
  yOff: 6,
  timer: 20000,
  outline: 1,
  rotAxis: "z",
  powerup: true,
  outlineScale: 1.1,
  onSpawn: vF85,
  getRotation: function () {
    return [UTILS.toRad(90), 0, 0];
  },
  onPickup: function (game) {
    for (var vLN01626 = game.AI.ais.length - 1; vLN01626 >= 0; --vLN01626) {
      if (game.AI.ais[vLN01626].team != 1) {
        game.AI.ais[vLN01626].kill();
      }
    }
    for (var vLN01626 = 0; vLN01626 < game.players.list.length; ++vLN01626) {
      game.players.score(game.players.list[vLN01626], 400);
    }
    game.broadcast("n", 1);
  },
  onDestroy: vF86
}, {
  name: "Minigun",
  model: "weapons/weapon_26",
  scale: 4,
  padMlt: 2500,
  yOff: 12,
  timer: 20000,
  outline: 1,
  powerup: true,
  onSpawn: vF85,
  getScale: function () {
    return 0.0026568026773869323;
  },
  stopInteract: function (p12695, p12696, p12697) {
    return !p12696 || !p12697 || p12697.isBot || p12697.hasEquipment();
  },
  onPickup: function (game, p12699, p12700) {
    game.players.giveWeapon(p12700, 25, false, true);
  },
  onDestroy: vF86
}, {
  name: "Insta-kill",
  model: "skull_0",
  scale: 3,
  yOff: 8,
  timer: 20000,
  outline: 1,
  powerup: true,
  outlineScale: 1.1,
  onSpawn: vF85,
  onPickup: function (p12701) {
    p12701.instaKillTimer = 30000;
    p12701.broadcast("pwup", 0, p12701.instaKillTimer);
  },
  onDestroy: vF86
}, {
  name: "Discount",
  model: "sale_0",
  scale: 2,
  padMlt: 1.5,
  yOff: 8,
  timer: 20000,
  outline: 1,
  powerup: true,
  outlineScale: 1.1,
  onSpawn: vF85,
  onPickup: function (p12702) {
    p12702.fireSaleTimer = 20000;
    p12702.broadcast("pwup", 1, p12702.fireSaleTimer);
    p12702.switchMysteryBox(p12702.getActiveMysteryBox(), true);
  },
  onDestroy: vF86
}, {
  name: "Double Points",
  model: "doublepoints_0",
  scale: 4,
  yOff: 8,
  timer: 20000,
  outline: 1,
  powerup: true,
  outlineScale: 1.1,
  onSpawn: vF85,
  onPickup: function (p12703) {
    p12703.doublePointsTimer = 30000;
    p12703.broadcast("pwup", 2, p12703.doublePointsTimer);
  },
  onDestroy: vF86
}, {
  name: "Grenade Launcher",
  model: "weapons/weapon_27",
  scale: 2,
  padMlt: 2,
  yOff: 8,
  timer: 20000,
  outline: 1,
  powerup: true,
  onSpawn: vF85,
  stopInteract: function (p12704, p12705, p12706) {
    return !p12705 || !p12706 || p12706.isBot || p12706.hasEquipment();
  },
  onPickup: function (game, p12708, p12709) {
    game.players.giveWeapon(p12709, 26, false, true);
  },
  onDestroy: vF86
}, {
  name: "Joe Tag",
  model: "tag_0",
  scale: 6,
  padMlt: 0.8,
  yOff: 6,
  timer: 20000,
  outline: 1,
  powerup: true,
  onSpawn: vF85,
  onPickup: function (game, p12711, p12712, p12713) {
    var v10176 = p12713.data && p12713.data.pnts ? p12713.data.pnts || 1 : 1;
    game.players.score(p12712, v10176);
  },
  onDestroy: vF86
}, {
  name: "Frog",
  model: "collectibles/collect_19",
  scale: 2,
  padMlt: 1.25,
  timer: 30000,
  noAnim: true,
  outline: 1,
  onSpawn: vF85,
  onPickup: function (p12714, p12715, p12716) {
    p12714.giveSkin(p12716, 5366, "zombies");
  },
  onDestroy: vF86
}, {
  name: "Krunkanium",
  model: "collectibles/collect_11",
  scale: 2,
  yOff: 6,
  timer: 30000,
  onPickup: function (p12717, p12718, p12719) {
    p12717.giveSkin(p12719, 4222, "killdrops");
    if (p12717.playSound) {
      p12717.playSound(config.networkSounds.indexOf("collect_1"), 1.2, p12719.sid, p12719.x, p12719.y, p12719.z, true);
    }
  }
}, {
  name: "Perk Bottle",
  model: "bottle_1",
  texSrc: "bottle_1_0",
  scale: 2,
  padMlt: 2,
  yOff: 8,
  timer: 30000,
  outline: 1,
  powerup: true,
  onSpawn: vF85,
  stopInteract: function (p12720, p12721, p12722) {
    return !p12721 || !p12722 || !!p12722.isBot || !(p12722.perks.length < config.zombiePerks.length);
  },
  onPickup: function (game, p12724, p12725) {
    var vA555 = [];
    for (var vLN01627 = 0; vLN01627 < config.zombiePerks.length; vLN01627++) {
      if (!p12725.perks.includes(vLN01627)) {
        vA555.push(vLN01627);
      }
    }
    if (vA555.length) {
      var v10177 = UTILS.getRandom(vA555);
      game.players.givePerk(p12725, v10177);
      game.playSound(30220, 2, 0, Math.round(p12725.x), Math.round(p12725.y), Math.round(p12725.z), true, 1, false, null, null, true, true);
    }
  },
  onDestroy: vF86
}, {
  name: "Zombie Portal",
  model: "zombie_portal_0",
  fileExt: "gltf",
  scale: 2,
  padMlt: 8,
  yOff: -1,
  timer: 15000,
  aiOnly: true,
  onSpawn: vF85,
  onPickup: function (p12726, p12727, p12728) {
    var v10178 = p12728.name;
    if (p12726.eePAPOrder[p12726.eePAPProgress] != v10178) {
      p12726.eePAPProgress = 0;
      p12726.broadcast("so", "mystery_1", 2, 1);
    } else {
      p12726.eePAPProgress++;
      p12726.broadcast("so", "collect_1", 2, 1);
      p12728.kill(null);
      if (p12726.eePAPProgress >= p12726.eePAPOrder.length) {
        p12726.eePAPCompleted = true;
        p12726.broadcast("so", "cheer_1", 2, 1);
        var v10179;
        for (var vLN01629 = 0; vLN01629 < p12726.map.manager.interfaces.length; ++vLN01629) {
          v10179 = p12726.map.manager.objects[p12726.map.manager.interfaces[vLN01629]];
          if (v10179.canDest && !v10179.destroyed && v10179.interface == 525) {
            v10179.active = false;
            v10179.health = 0;
            v10179.destroyed = true;
            p12726.map.manager.destObjs.push(v10179.uid);
            p12726.broadcast("do", v10179.uid);
            break;
          }
        }
        p12726.eeDanceTimer = 122000;
        for (var vLN01629 = 0; vLN01629 < p12726.eeDanceSkullSpawns.length; vLN01629++) {
          p12726.dropSpawnable(21, null, null, {
            x: p12726.eeDanceSkullSpawns[vLN01629].x,
            y: p12726.eeDanceSkullSpawns[vLN01629].y,
            z: p12726.eeDanceSkullSpawns[vLN01629].z
          });
        }
      }
    }
  },
  onDestroy: function (p12729, p12730, p12731, p12732) {
    if (!p12730 && p12732 && p12732.soundData) {
      p12732.soundData[0].isPlaying = false;
      p12732.soundData[0].stop(p12732.soundData[1]);
      p12732.soundData = null;
    }
    if (p12730 && p12729 && !p12729.eePAPCompleted) {
      p12729.eePAPActive = false;
      p12729.globalVals.portal = 0;
      p12729.broadcast("gv", "portal", p12729.globalVals.portal);
    }
  }
}, {
  name: "Skull EE",
  model: "skull_0",
  scale: 3,
  noAnim: true,
  timer: 120000,
  powerup: true,
  canShoot: true,
  onShoot: function (p12733, p12734, p12735) {
    if (p12733.playSound) {
      p12733.playSound(config.networkSounds.indexOf("collect_1"), 1.2, p12735.sid, p12735.x, p12735.y, p12735.z, true);
    }
    p12733.eeDanceSkulls++;
    if (p12733.eeDanceSkulls >= p12733.eeDanceSkullSpawns.length && !p12733.eeDanceCompleted) {
      p12733.eeDanceCompleted = true;
      p12733.eeDanceTimer = 0;
      p12733.AI.forceDanceTimer = 10000;
      p12733.AI.forceDance = true;
      p12733.broadcast("so", "cheer_0", 2, 1);
      var v10180 = p12733.map.spawns[0];
      var vA556 = [22, 19];
      for (var vLN01631 = 0; vLN01631 < 4; vLN01631++) {
        p12733.dropSpawnable(UTILS.getRandom(vA556), null, null, {
          x: v10180.x + UTILS.randInt(15, 25) * UTILS.getRandom([1, -1]),
          y: v10180.y,
          z: v10180.z + UTILS.randInt(15, 25) * UTILS.getRandom([1, -1])
        });
      }
      for (var vLN01631 = 0; vLN01631 < p12733.map.manager.interfaces.length; ++vLN01631) {
        var v10181 = p12733.map.manager.objects[p12733.map.manager.interfaces[vLN01631]];
        var v10182 = p12733.map.manager.destObjs.indexOf(v10181.uid);
        if (v10182 != -1 && v10181.interface == 252) {
          p12733.map.manager.destObjs.splice(v10182, 1);
          v10181.active = true;
          v10181.destroyed = false;
          v10181.respawnT = v10181.respawnR ? 0 : v10181.respawnTStart;
          if (v10181.health != null) {
            v10181.health = v10181.startHealth;
          }
          p12733.broadcast("ro", v10181.uid);
          v10181.destroyedBy = null;
        }
      }
    } else {
      ;
    }
  }
}, {
  name: "Free Upgrade",
  model: "krummachine_0",
  scale: 2,
  yOff: 8,
  timer: 30000,
  outline: 1,
  onSpawn: vF85,
  stopInteract: function (p12736, p12737, p12738) {
    return !p12737 || !p12738 || !p12738.canUpgrade();
  },
  onPickup: function (game, p12740, p12741) {
    if (game.playSound) {
      game.playSound(config.networkSounds.indexOf("collect_1"), 1.2, p12741.sid, p12741.x, p12741.y, p12741.z, true);
    }
    var v10183 = p12741.loadout[p12741.loadoutIndex];
    game.players.removeWeapon(p12741, v10183);
    game.players.giveWeapon(p12741, v10183, true, true);
  },
  onDestroy: vF86
}, {
  name: "Mega Slime Pad",
  model: "pad_1",
  scale: 20,
  yOff: 1,
  noAnim: true,
  timer: 10000,
  alwaysActive: true,
  getRotation: function (p12742) {
    return [UTILS.toRad(p12742.xD), 0, UTILS.toRad(p12742.zD)];
  },
  onCollision: function (p12743, p12744, p12745, p12746) {
    var vLN02252 = 0.225;
    var v10184 = p12746.data && p12746.data.xD ? p12746.data.xD || 0 : 0;
    var v10185 = p12746.data && p12746.data.zD ? p12746.data.zD || 0 : 0;
    var v10186 = !v10184 && !v10185 || v10185 == 180;
    if (v10184) {
      v10184 -= 90;
    }
    if (!v10186) {
      v10184 = UTILS.toRad(v10184);
      v10185 = UTILS.toRad(v10185);
      var v10187 = vLN02252 * Math.sin(-v10185) * Math.cos(v10184);
      var v10188 = vLN02252 * Math.cos(-v10185) * Math.cos(v10184);
      if (v10187) {
        p12745.velocity.x = v10187;
      }
      if (v10188) {
        p12745.velocity.z = v10188;
      }
    } else {
      p12745.velocity.y = vLN02252 * (v10185 == 180 ? -1 : 1);
    }
    if (p12745.isYou && !p12745.wasOnPad) {
      SOUND.play("bounce_1", 1, false, UTILS.randFloat(0.95, 1));
    }
    p12745.onGround = false;
    p12745.onPad = true;
  }
}, {
  name: "Loot Drop",
  model: "cardb_0",
  scale: 4,
  padMlt: 1.5,
  yOff: 8,
  playerSpecific: true,
  outline: 0,
  getRotation: function (p12747) {
    return [0, p12747.xD, 0];
  },
  onPickup: function (p12748, p12749, p12750, p12751) {
    if (p12751.data && p12751.data.itemId != null) {
      p12748.giveSkin(p12750, p12751.data.itemId, p12751.data.reason);
    }
    if (p12748.playSound) {
      p12748.playSound(config.networkSounds.indexOf("aim_1"), 2, p12750.sid, p12750.x, p12750.y, p12750.z, true);
    }
  }
}];
var vLN01632 = 0;
module.exports.getData = function (p12752, p12753, p12754, p12755, p12756, p12757, p12758, p12759, p12760, p12761, p12762, p12763) {
  p12760 = p12760 || {};
  return {
    i: p12752,
    x: p12754,
    y: p12755,
    z: p12756,
    team: p12758,
    timer: p12759 || 0,
    sid: p12753 || vLN01632++,
    width: p12757,
    length: p12757,
    height: p12757 / 2,
    ai: ~~!!p12761,
    shoot: ~~!!p12762,
    pid: p12763,
    data: p12760
  };
};